import Vue from 'vue'
import AppendGeojsonPrototype from './GetGeojson'

let _geojsonAppended = false

Vue.$bvueGmapWaitGoogleReady = () => new Promise((resolve, reject) => {
  (function $recheck () {
    if (window.google) {
      if (!_geojsonAppended) {
        AppendGeojsonPrototype()
        _geojsonAppended = true
      }
      return resolve()
    }
    else setTimeout($recheck, 100)
  }())
})


export default {
  template: '<div ref="map" class="bvue-gmap"></div>',
  props: {
    center: Array,
    zoom: { type: Number, default: 9 },
    options: { type: Object }
  },
  watch: {
    center () {
      this.$center()
    },
    zoom () {
      this.map.set('zoom', this.zoom)
    },
    options: {
      deep: true,
      handler () {
        this.$updateMapOptions()
      }
    }
  },
  methods: {
    async $initializeMap (centerMap = true) {
      await Vue.$bvueGmapWaitGoogleReady()
      this.map = new window.google.maps.Map(this.$refs.map)
      this.$updateMapOptions()
      window.google.maps.event.addListener(this.map, 'click', (event) => {
        this.$emit('click', [event.latLng.lng(), event.latLng.lat()])
      })
      if (centerMap) {
        this.$center()
      }
    },
    $center (coords = null) {
      if (!this.map) return
      const centerCoords = coords || this.$resolveCenter()
      this.map.setCenter(new window.google.maps.LatLng(centerCoords[1], centerCoords[0]))
    },
    $resolveCenter () {
      return [...(this.center || Vue.$bvueGmapDefaults.center || [-2.97774451, 43.24928996])]
    },
    $updateMapOptions (log) {
      if (!this.map) return
      this.map.set('zoom', this.zoom)
      Object.keys(this.options || {}).forEach((key) => {
        this.map.set(key, this.options[key])
      })
    }
  },
  detroyed () {
    // this.map.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/plugin/mixins/GmapMixin.js